// extracted by mini-css-extract-plugin
export default {"container":"PungoInput_container__ltaFG","formControl":"PungoInput_formControl__gWw9O"};